import { render, staticRenderFns } from "./ConnectedLayout.vue?vue&type=template&id=3bb10430&scoped=true&"
import script from "./ConnectedLayout.vue?vue&type=script&lang=ts&"
export * from "./ConnectedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectedLayout.vue?vue&type=style&index=0&id=3bb10430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb10430",
  null
  
)

export default component.exports